/*
 * Parser for the requirement hours-cap errors raised by the DB trigger
 * fn_enforce_requirement_hours_cap (fires on INSERT and UPDATE of time_logs):
 *   'HORAS_CAP_NULL|<reference_id>'
 *   'HORAS_CAP_EXCEDIDAS|<reference_id>|<cap>|<consumed>|<incoming>|<remaining>'
 */
export function parseHoursCapError(msg) {
  if (!msg) return null;
  const parts = msg.split('|');
  if (parts[0] === 'HORAS_CAP_NULL')
    return { type: 'null_cap', refId: parts[1] || '' };
  if (parts[0] === 'HORAS_CAP_EXCEDIDAS')
    return {
      type: 'exceeded', refId: parts[1] || '',
      cap: parseFloat(parts[2]) || 0,
      consumed: parseFloat(parts[3]) || 0,
      incoming: parseFloat(parts[4]) || 0,
      remaining: Math.max(0, parseFloat(parts[5]) || 0),
    };
  return null;
}
